/* A color per team (teacher), the same in the team pills and the team cards.
   Each name gets the palette color its letters point to; when two teams would share one,
   the next free color is used (names in alphabetical order, so the colors don't jump around). */
export const TEAM_PALETTE = ['#3FA2FF', '#F7931E', '#12C08A', '#E5484D', '#8B5CF6', '#FFC21F', '#14B8A6', '#EC4899', '#84CC16', '#06B6D4'];

const hash = (s) => [...String(s || '').toLowerCase()].reduce((h, ch) => (h * 31 + ch.charCodeAt(0)) >>> 0, 7);

export const teamColors = (names) => {
  const out = new Map();
  const used = new Set();
  [...new Set(names.filter(Boolean))].sort((a, b) => a.localeCompare(b)).forEach((n) => {
    let i = hash(n) % TEAM_PALETTE.length;
    for (let k = 0; k < TEAM_PALETTE.length && used.has(i); k += 1) i = (i + 1) % TEAM_PALETTE.length;
    used.add(i);
    out.set(n, TEAM_PALETTE[i]);
  });
  return out;
};
